import { render, staticRenderFns } from "./activeIndex.vue?vue&type=template&id=56f823ae&scoped=true&"
import script from "./activeIndex.vue?vue&type=script&lang=js&"
export * from "./activeIndex.vue?vue&type=script&lang=js&"
import style0 from "./activeIndex.vue?vue&type=style&index=0&id=56f823ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f823ae",
  null
  
)

export default component.exports